import { useMutation, useQueryClient } from "@tanstack/react-query";
import { salveazaTargetarePersoana } from "@/api/endpoints/targetareContacte";
import { queryKeys } from "@/lib/queryClient";

export function useSalveazaTargetarePersoana() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: salveazaTargetarePersoana,
    onSuccess: (_, variabile) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.targetare.firma(variabile.cui),
      });
    },
  });
}
